// extracted by mini-css-extract-plugin
export default {"topContainer":"Wallet_topContainer__1N2kT"};